import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=6167addc&scoped=true&"
import script from "./PriceSummary.vue?vue&type=script&lang=js&"
export * from "./PriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./PriceSummary.vue?vue&type=style&index=0&id=6167addc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167addc",
  null
  
)

export default component.exports